<div class="w-full h-full flex flex-col gap-6">
  <div class="bg-white border border-gray-200 rounded-xl shadow-sm flex flex-col">
    <div class="p-6 flex flex-col gap-6">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-end">
        <div class="field">
          <p-floatlabel variant="on">
            <p-datepicker
              inputId="startDate"
              [ngModel]="startDate()"
              (ngModelChange)="onStartDateChange($event)"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [showButtonBar]="true"
              [maxDate]="endDate() || undefined"
              appendTo="body"
              class="w-full"
            />
            <label for="startDate">Fecha de Inicio <span class="text-red-500">*</span></label>
          </p-floatlabel>
        </div>

        <div class="field">
          <p-floatlabel variant="on">
            <p-datepicker
              inputId="endDate"
              [ngModel]="endDate()"
              (ngModelChange)="onEndDateChange($event)"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [showButtonBar]="true"
              [minDate]="minEndDate()"
              appendTo="body"
              class="w-full"
            />
            <label for="endDate">Fecha de Fin <span class="text-red-500">*</span></label>
          </p-floatlabel>
        </div>

        <div class="flex items-center gap-2 md:justify-end">
          <p-button
            icon="pi pi-question-circle"
            [rounded]="true"
            [text]="true"
            severity="secondary"
            pTooltip="Ver manual"
            tooltipPosition="bottom"
            (onClick)="openUserManual()"
          />
          <p-button
            icon="pi pi-filter-slash"
            [rounded]="true"
            [text]="true"
            severity="secondary"
            pTooltip="Limpiar filtros"
            tooltipPosition="bottom"
            (onClick)="clearFilters()"
            [disabled]="loading()"
          />
          <p-button
            label="Buscar"
            icon="pi pi-search"
            (onClick)="generateReport()"
            [loading]="loading()"
          />
        </div>
      </div>

      <p class="text-sm font-medium text-gray-500 m-0">
        Identifica huecos de vigencia en configuraciones de tarifas por zona comercial, condición comercial y zona horaria.
      </p>

      @if (validationError()) {
        <p-message severity="warn" [text]="validationError()" />
      }

      @if (requestError()) {
        <p-message severity="error" [text]="requestError()" />
      }
    </div>
  </div>

  @if (hasSearched()) {
    <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex flex-col min-h-[420px]">
      <div class="flex-1 overflow-auto relative w-full">
        <p-table
          [value]="tableData()"
          [loading]="loading()"
          class="p-datatable-modern"
          [scrollable]="true"
          scrollHeight="flex"
        >
          <ng-template pTemplate="header">
            <tr class="bg-gray-50/80 border-b border-gray-100">
              @for (col of columns; track col.field) {
                <th class="py-3 px-4 text-xs font-bold text-gray-600 uppercase tracking-wider whitespace-nowrap">
                  {{ col.header }}
                </th>
              }
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr class="group transition-colors border-b border-gray-50 hover:bg-slate-50/80 h-14">
              <td class="px-4 py-2 text-sm text-gray-600 whitespace-nowrap">{{ item.reason_label }}</td>
              <td class="px-4 py-2 text-sm text-gray-600 whitespace-nowrap">{{ item.commercial_zone_name }}</td>
              <td class="px-4 py-2 text-sm text-gray-600 whitespace-nowrap">{{ item.commercial_condition_name }}</td>
              <td class="px-4 py-2 text-sm text-gray-600 whitespace-nowrap">{{ item.timezone_name }}</td>
              <td class="px-4 py-2 text-sm text-gray-600 whitespace-nowrap">{{ item.gap_start_date_view }}</td>
              <td class="px-4 py-2 text-sm text-gray-600 whitespace-nowrap">{{ item.gap_end_date_view }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center py-20">
                <div class="flex flex-col items-center justify-center text-gray-400">
                  <i class="pi pi-search text-2xl mb-3"></i>
                  <p class="text-sm">No se encontraron configuraciones faltantes en el periodo seleccionado.</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>
